import { render, staticRenderFns } from "./EventLogDetailView.vue?vue&type=template&id=cad83124&scoped=true&"
import script from "./EventLogDetailView.vue?vue&type=script&lang=js&"
export * from "./EventLogDetailView.vue?vue&type=script&lang=js&"
import style0 from "./EventLogDetailView.vue?vue&type=style&index=0&id=cad83124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad83124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VDialog,VTextField})
